import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Table } from 'react-bootstrap-5';
import UltimatePagination from 'react-ultimate-pagination-bootstrap-4';

import Button from 'shared/button';
import { get } from 'helpers/api';
import { clickAsLink } from 'helpers/link_helpers';

import LoadingSpinner from "components/loading_spinner";
import { steps } from './push_contacts_constants';

export default class PushResults extends React.Component {
  static propTypes = {
    batch: PropTypes.object.isRequired,
    editUserPath: PropTypes.string,
    isSameUser: PropTypes.bool,
    profileSettingsPath: PropTypes.string.isRequired,
    onChangeStep: PropTypes.func.isRequired
  }

  state = {
    records: [],
    currentPage: 1,
    pageSize: 25,
    totalCount: 0,
    totalPages: 0,
    loadingContacts: false,
    successCount: 0,
    failedCount: 0
  }

  componentDidMount() {
    this.getRecords();
  }

  statusClass = (status) => {
    let statusClass;

    switch (status) {
    case "Failed":
      statusClass = classNames({ "text-yellow": true });
      break;
    default:
      statusClass = classNames({ "text-success": true });
    }

    return statusClass;
  }

  getRecords = () => {
    const { batch } = this.props;
    const { currentPage, pageSize } = this.state;

    this.setState({ loadingContacts: true });

    return get(batch.paths.batchRecordsPath, {
      params: {
        page: currentPage,
        pageSize: pageSize
      }
    }).then((results) => {
      this.setState({
        ...results.meta,
        records: results.records,
        loadingContacts: false,
        successCount: results.successCount,
        failedCount: results.failedCount
      });
    });
  }

  handleBackToPage = (e, path) => clickAsLink(window, path, e);

  handlePageChange = (page) => {
    this.setState({ currentPage: page }, () => {
      this.getRecords();
    });
  };

  render() {
    const { successCount, failedCount } = this.state;
    return (
      <div className="push-contacts container">
        <div className="page-header">
          <h5 className="mb-2">
            Contacts Pushed
          </h5>
          <p>
            {successCount} successfully imported.
            {failedCount > 0 && " " + failedCount + " contacts unsuccessfully imported"}
          </p>
        </div>
        {this.renderPushResultsContainer()}
      </div>
    );
  }

  renderPushResultsContainer() {
    const { loadingContacts } = this.state;

    return (
      <div className="container merge-container bg-card border-top-0 p-4">
        <p>
          Push Results
        </p>
        {loadingContacts ?
          <LoadingSpinner /> :
          <React.Fragment>
            {this.renderResultsTable()}
            {this.renderPagination()}
            {this.renderButtons()}
          </React.Fragment>
        }
      </div>
    );
  }


  renderResultsTable() {
    return (
      <div>
        <Table className="align-middle">
          <thead>
            {this.renderHeaderColumns()}
          </thead>
          <tbody>
            {this.renderTableContent()}
          </tbody>
        </Table>
      </div>
    );
  }

  renderHeaderColumns() {
    return (
      <tr key="headers">
        <th className="fw-semibold">Status</th>
        <th className="fw-semibold">First Name</th>
        <th className="fw-semibold">Last Name</th>
        <th className="fw-semibold">Report</th>
      </tr>
    );
  }

  renderTableContent() {
    const { records } = this.state;

    return records.map((record) => {

      return (
        <tr key={record.id}>
          <td className={this.statusClass(record.status)}>{record.status}</td>
          <td>{record.contactsPerson.firstName}</td>
          <td>{record.contactsPerson.lastName}</td>
          <td>{record.message}</td>
        </tr>
      );
    });
  }

  renderButtons() {
    const { profileSettingsPath, onChangeStep, editUserPath, isSameUser } = this.props;
    const backRoute = isSameUser ? profileSettingsPath : editUserPath;

    return (
      <div className="d-flex justify-content-end gap-3 mt-3">
        <Button.Secondary label="Back To Integrations" onClick={e => this.handleBackToPage(e, backRoute)} />
        <Button.Primary label="Push Contacts" onClick={() => onChangeStep(steps.selectContacts)} />
      </div>
    );
  }


  renderPagination() {
    const { records, totalCount, currentPage, totalPages } = this.state;
    if (records.length < totalCount) {
      return (
        <div className="text-center">
          <UltimatePagination
            currentPage={currentPage}
            totalPages={totalPages}
            onChange={this.handlePageChange}
          />
        </div>
      );
    }
  }
}
